export default __webpack_public_path__ + "static/media/art-pro-slt-poster-1.d6514392.jpg";